import React from 'react'
import Conditional from '../common/Conditional'

export interface IWorkplaceQuizProgressbarRowProps {
  index: number
  currentPoint: boolean
  finished: boolean
  cssWidth: number
}

const WorkplaceQuizProgressbarRow = (
  props: IWorkplaceQuizProgressbarRowProps
) => {
  const liStyle = {
    width: props.cssWidth + '%',
  }

  return (
    <li
      key={props.index}
      className={
        props.currentPoint ? 'progressPoint currentPoint' : 'progressPoint'
      }
      style={liStyle}
    >
      <Conditional if={!props.finished}>
        <span className="finished"></span>
      </Conditional>
      <Conditional if={props.finished}>
        <span></span>
      </Conditional>
    </li>
  )
}

export default WorkplaceQuizProgressbarRow
